import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Alert, Container } from 'react-bootstrap';

const BusinessRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Container className="mt-5 text-center">
        <div className="loading-spinner" style={{ margin: '0 auto', width: '40px', height: '40px' }}></div>
        <p className="mt-3">Loading...</p>
      </Container>
    );
  }

  // Check if user has a business profile
  if (!user || !user.business) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">
          <Alert.Heading>Business Profile Required</Alert.Heading>
          <p>You need to complete your business profile to access this page.</p>
          <p>Please contact support if you believe this is an error.</p>
        </Alert>
      </Container>
    );
  }

  return children;
};

export default BusinessRoute;
